import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheckmarkCircle = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 30,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M16 6.96 14.56 5.5l-5.996 6.078L5.44 8.412 4 9.873 8.564 14.5 16 6.96z",
		fill: "#111"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M10 20c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16z",
		fill: "#111"
	})]
});
export default SvgCheckmarkCircle;
